import React from "react";
import { useTranslation } from "react-i18next";
import { CiCalendar, CiClock1 } from "react-icons/ci";
import { Link } from "react-router-dom";
import "./style.css";
import { Button, Form, FormProps, Input } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { submitData } from "./request";
import { Notification } from "../../../../utils/notification";
import { AxiosError } from "axios";

type FieldType = {
    email?: string;
};

const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
};


const ArbitrationEventSection: React.FC = () => {
    const { t } = useTranslation()
    const queryClient = useQueryClient();
    const [form] = Form.useForm()

    const { mutate } = useMutation({
        mutationFn: (newVals) => submitData(undefined, newVals),
        onSuccess: async (res) => {
          queryClient.setQueryData(["subscriptions"], res);
          Notification("success","create", `${t('You have successfully subscribed to the system!')}`)
          form?.resetFields()
        },
        onError: (error: AxiosError) => {
          Notification(`error`,"create", error?.name)
        },
        retry: 0,
      });

    return (
        <>
            <div className="sm:py-10 py-5 bg-main_color w-full sm:my-16 my-5">
                <div className="container mx-auto px-5">
                    <div className="flex items-center max-sm:flex-col sm:justify-between justify-center text-white gap-5">
                        <div className=" max-sm:text-center max-sm:flex max-sm:flex-col max-sm:items-center sm:w-1/2 w-full">
                            {/* <h3 className="font-semibold lg:text-xl text-base">{t('Ask us a question about your arbitration clause')}</h3> */}
                            <p className="font-medium sm:text-base text-sm max-sm:w-5/6">{t('Do you have any questions regarding the possibility of applying an alternative dispute resolution method for the relevant disputes or the validity of an existing arbitration agreement? We are ready to provide an answer!')}</p>
                        </div>
                        <Form
                            form={form}
                            className="flex items-center sm:w-1/2 w-full gap-3"
                            onFinish={(values: any) => mutate(values)}
                            onFinishFailed={onFinishFailed}
                        >
                            <Form.Item name={'email'} className="w-4/5" rules={[{ required: true, message: `${t('Please input your email!')}` }]}>
                                <Input type="email" className="w-full py-2 mr-4" placeholder="Enter email ..." name="email" allowClear/>
                            </Form.Item>
                            <Form.Item className="w-1/5 min-w-fit">
                                <Button htmlType="submit" className="subscribe text-center w-full h-[41px] bg-transparent text-white rounded border border-solid border-white sm:text-sm text-xs">{t('Subscribe')}</Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
            {/* <div className="lg:px-20 sm:px-10 px-5 mx-auto mb-20">
                <div className="max-w-[1681px] mx-auto">
                    <h3 className="font-bold text-main_color text-[30px] capitalize">{t('Events')}</h3>
                    <div className="flex flex-wrap -m-4 mt-6">
                        <Link to={'/events'} className="lg:w-1/4 sm:w-1/2 p-2">
                            <div className="bg-[#D9E7F0] rounded p-3 px-4 ">
                                <div className="border-l-2 border-solid border-main_color pl-3">
                                    <h3 className="font-bold text-main_color text-base uppercase">{t('EVENTS')}</h3>
                                    <p className="text-main_color lg:text-base text-[13px] font-semibold mt-3">
                                        {t('RAC Business Breakfast “Arbitration and Courts in the UAE: Two Halves of a Whole? UAE Courts Assistance in Support of Arbitration”')}
                                    </p>
                                    <div className="flex items-center justify-between gap-4 mt-4">
                                        <span className="flex text-[#29487E] items-center text-xs font-semibold"><CiCalendar size={16} className="mr-2" /> 14 - May. 2024</span>
                                        <span className="flex text-[#29487E] items-center text-xs font-semibold"><CiClock1 size={16} className="mr-2" /> 09:00 - 12:00 (GMT+4)</span>
                                    </div>
                                </div>
                            </div>
                        </Link>
                        <Link to={'/events'} className="lg:w-1/4 sm:w-1/2 p-2">
                            <div className="bg-[#D9E7F0] rounded p-3 px-4">
                                <div className="border-l-2 border-solid border-main_color pl-3">
                                    <h3 className="font-bold text-main_color text-base uppercase">{t('EVENTS')}</h3>
                                    <p className="text-main_color  lg:text-base text-[13px] font-semibold mt-3">
                                        {t('RAC Business Breakfast “Arbitration and Courts in the UAE: Two Halves of a Whole? UAE Courts Assistance in Support of Arbitration”')}
                                    </p>
                                    <div className="flex items-center justify-between gap-4 mt-4">
                                        <span className="flex text-[#29487E] items-center text-xs font-semibold"><CiCalendar size={16} className="mr-2" /> 14 - May. 2024</span>
                                        <span className="flex text-[#29487E] items-center text-xs font-semibold"><CiClock1 size={16} className="mr-2" /> 09:00 - 12:00 (GMT+4)</span>
                                    </div>
                                </div>
                            </div>
                        </Link>
                        <Link to={'/events'} className="lg:w-1/4 sm:w-1/2 p-2">
                            <div className="bg-[#D9E7F0] rounded p-3 px-4">
                                <div className="border-l-2 border-solid border-main_color pl-3">
                                    <h3 className="font-bold text-main_color text-base uppercase">{t('EVENTS')}</h3>
                                    <p className="text-main_color lg:text-base text-[13px] font-semibold mt-3">
                                        {t('RAC Business Breakfast “Arbitration and Courts in the UAE: Two Halves of a Whole? UAE Courts Assistance in Support of Arbitration”')}
                                    </p>
                                    <div className="flex items-center justify-between gap-4 mt-4">
                                        <span className="flex text-[#29487E] items-center text-xs font-semibold"><CiCalendar size={16} className="mr-2" /> 14 - May. 2024</span>
                                        <span className="flex text-[#29487E] items-center text-xs font-semibold"><CiClock1 size={16} className="mr-2" /> 09:00 - 12:00 (GMT+4)</span>
                                    </div>
                                </div>
                            </div>
                        </Link>
                        <Link to={'/events'} className="lg:w-1/4 sm:w-1/2 p-2">
                            <div className="bg-[#D9E7F0] rounded p-3 px-4">
                                <div className="border-l-2 border-solid border-main_color pl-3">
                                    <h3 className="font-bold text-main_color text-base uppercase">{t('EVENTS')}</h3>
                                    <p className="text-main_color lg:text-base text-[13px] font-semibold mt-3">
                                        {t('RAC Business Breakfast “Arbitration and Courts in the UAE: Two Halves of a Whole? UAE Courts Assistance in Support of Arbitration”')}
                                    </p>
                                    <div className="flex items-center justify-between gap-4 mt-4">
                                        <span className="flex text-[#29487E] items-center text-xs font-semibold"><CiCalendar size={16} className="mr-2" /> 14 - May. 2024</span>
                                        <span className="flex text-[#29487E] items-center text-xs font-semibold"><CiClock1 size={16} className="mr-2" /> 09:00 - 12:00 (GMT+4)</span>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>

            </div> */}
        </>
    )
}

export default ArbitrationEventSection